import CopyUrlButton from "../../../../../../../../components/btns/CopyLinkBtn";
import LabelledBox from "../../../../../../../../components/widgets/LabelledBox";
import { useBidContext } from "../Bid.context";
import { Box, Typography } from "@mui/material";
import BidTable from "../BidTable";
import { BidTableButton } from "./POSubmissionBtn";

const BidEvaluationView = () => {
  const { mrqData, plant } = useBidContext();
  const totalCost = 0;
  const link =
    `/plant/${plant.id}/mcs#mcs-tab=Drawing+BOM&bom-tab=Bid+Evaluation&mrq-id=` +
    mrqData?.id;
  return (
    <LabelledBox label="Bid Table" sx={{ position: "relative" }}>
      {mrqData?.id && (
        <CopyUrlButton
          label="Copy Bids Link"
          sx={{ position: "absolute", top: -40, right: 5 }}
          subLink={link}
        />
      )}
      {mrqData?.id && (
        <Typography
          sx={{ position: "absolute", top: 5, right: 10, color: "#888" }}
        >
          ID: {mrqData?.id}
        </Typography>
      )}
      <BidTable totalCost={totalCost} />
      <Box sx={{ p: 2, pb: 0 }}>
        <BidTableButton />
      </Box>
    </LabelledBox>
  );
};

export default BidEvaluationView;